<div class="welcome-container">
  <div class="welcome-hero">
    <h1 class="welcome-titulo">
      Bem-vindo ao <span class="destaque">MeuCardápio</span>
    </h1>
    <p class="welcome-subtitulo">
      Configure sua loja em poucos minutos e comece a vender hoje mesmo.
    </p>
  </div>

  <div class="welcome-btn-wrapper">
    <button class="welcome-btn" (click)="comecar()">
      Começar agora <i class="fe-arrow-right ml-2"></i>
    </button>
  </div>

  <div class="welcome-separador" aria-hidden="true"></div>

  <div class="welcome-beneficios">
    <div class="beneficio">
      <div class="beneficio-icone beneficio-icone-mia">
        <i class="fa fa-robot"></i>
      </div>
      <div class="beneficio-texto">
        <strong>Mia — IA de verdade</strong>
        <span>Atendente virtual que responde clientes e tira dúvidas automaticamente.</span>
      </div>
    </div>

    <div class="beneficio">
      <div class="beneficio-icone beneficio-icone-cardapio">
        <i class="fa fa-utensils"></i>
      </div>
      <div class="beneficio-texto">
        <strong>Cardápio digital completo</strong>
        <span>Seus clientes pedem direto pelo celular, sem precisar de app.</span>
      </div>
    </div>

    <div class="beneficio">
      <div class="beneficio-icone beneficio-icone-pedidos">
        <i class="fa fa-bell"></i>
      </div>
      <div class="beneficio-texto">
        <strong>Pedidos em tempo real</strong>
        <span>Receba pedidos pelo WhatsApp ou painel, sem comissão.</span>
      </div>
    </div>

    <div class="beneficio">
      <div class="beneficio-icone beneficio-icone-pagamento">
        <i class="fa fa-credit-card"></i>
      </div>
      <div class="beneficio-texto">
        <strong>Pagamento online</strong>
        <span>Pix, cartão e mais - tudo integrado no seu cardápio.</span>
      </div>
    </div>
  </div>

  <div class="welcome-tempo">
    <i class="fe-clock"></i>
    <span>Leva menos de <strong>3 minutos</strong> para configurar</span>
  </div>
</div>
